import React from 'react'
import FormProductGeneralInfo from '../productsAuxForm/FormProductGeneralInfo'

const ProductGeneralInfo = ({
  inputs,
  handleChange,
  categories,
  fathersArticle,
}) => {
  return (
    <>
      <h2 className='mb-30 products__subtitle'>Información general</h2>
      <FormProductGeneralInfo
        inputs={inputs}
        handleChange={handleChange}
        categories={categories}
        newProduct={false}
        fathersArticle={fathersArticle}
      />
    </>
  )
}
export default ProductGeneralInfo
